import { useState } from 'react';
import { Modal, TitleBar } from '@shopify/app-bridge-react';
import { Box, Text } from '@shopify/polaris';
import { ICardMediaAsset } from '@/types/media';
import useUpdateMedia from '@/hooks/useUpdateMedia';
import { Avatar } from '@/types/avatar';
import { PersonalAvatarViewData } from '@/api/personal-avatars';
import BasicBanner from '@/components/BasicBanner';

type DeleteMediaAssetModalProps = {
  mediaAsset: ICardMediaAsset | Avatar | PersonalAvatarViewData;
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
};

export const DeleteMediaAssetModal = ({ mediaAsset, isOpen, setIsOpen }: DeleteMediaAssetModalProps) => {
  const [error, setError] = useState('');
  const { deleteMutation } = useUpdateMedia(mediaAsset, {
    onSuccess: () => {
      setIsOpen(false);
    },
    onError: (asset) => {
      setError(`Failed to delete ${asset}`);
    },
  });

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleDelete = () => {
    if (deleteMutation.isPending) return;
    deleteMutation.mutate();
  };

  return (
    <Modal open={isOpen} onHide={handleClose} variant="small">
      <TitleBar title="Delete Creation">
        <button variant="primary" onClick={handleDelete} disabled={deleteMutation.isPending}>
          Delete
        </button>
        <button onClick={handleClose} disabled={deleteMutation.isPending}>
          Cancel
        </button>
      </TitleBar>
      <Box padding="400">
        <BasicBanner
          tone="critical"
          title="Error"
          hidden={!error}
          boxComponentProps={{ paddingBlockEnd: '200' }}
          onDismiss={() => setError('')}
        >
          {error}
        </BasicBanner>
        <Text as="p" variant="headingSm">
          Are you sure you want to delete this creation?
        </Text>
      </Box>
    </Modal>
  );
};
